// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';
import translationUK from './locales/uk/translation.json';

void i18n.use(initReactI18next).init({
  resources: {
    'en-US': {
      translation: translationEN
    },
    'ru-RU': {
      translation: translationRU
    },
    'uk-UK': {
      translation: translationUK
    }
  },
  lng: 'en-US',
  fallbackLng: 'en-US',
  preload: ['en-US', 'uk-UK', 'ru-RU'],
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
